import { Page, PageType } from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const GET_PAGE = '[sap-cms] Get Page';
export const LOAD_PAGE = '[sap-cms] Load page';
export const LOAD_PAGE_FAIL = '[sap-cms] Load page Fail';
export const LOAD_PAGE_SUCCESS = '[sap-cms] Load page Success';
export const SET_ACTIVE_PAGE = '[sap-cms] Set active Page';
export const GET_404_PAGE = '[sap-cms] Get 404 Page';
export const LOAD_404_PAGE = '[sap-cms] Load 404 Page';
export const RESET_PAGE = '[sap-cms] Reset page';

export const resetCmsPage = createAction(RESET_PAGE);

export const getPage = createAction(
  GET_PAGE,
  props<{ label: string; pageType: PageType }>(),
);

export const loadPage = createAction(
  LOAD_PAGE,
  props<{ label: string; pageType: PageType }>(),
);

export const loadPageSuccess = createAction(
  LOAD_PAGE_SUCCESS,
  props<{ culture: string; page: Page; label: string }>(),
);

export const loadPageFail = createAction(
  LOAD_PAGE_FAIL,
  props<{ errorMessage: string; label: string; previousLabel: string }>(),
);

export const get404Page = createAction(
  GET_404_PAGE,
  props<{ label: string; pageType: PageType }>(),
);

export const load404Page = createAction(
  LOAD_404_PAGE,
  props<{ label: string; pageType: PageType }>(),
);

export const setActivePage = createAction(
  SET_ACTIVE_PAGE,
  props<{ page: Page }>(),
);
